export default __webpack_public_path__ + "static/media/GroupBrain959.f0f9043f.svg";